import React from 'react';
import classes from "./sessions.module.css";
import Title from '../../containers/title/title';
import CampOffer from '../../containers/campOffer/campOffer';
import Form from './form/form';

const Sessions = (props) => {
    const bookNowClickedHandler = (plan) => {
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            props.setShowCampRegistrationForm(true);
            if (props.setSelectedPlan) props.setSelectedPlan(plan);
        }
    }
    return (
        <div className={classes.Container}>
            <Title title={props.title} camp={props.camp} />
            <div className={classes.Background} style={{backgroundImage: `url(${props.background})`}}>
                <div className={classes.DarkEffect}>
                    <p className={classes.Description}>{props.description}</p>
                    <div className={classes.Session}>{props.offers?.map((offer) =>
                        <CampOffer {...offer} key={offer.id} clicked={() => bookNowClickedHandler(offer)} />
                    )}</div>
                    <div className={classes.OtherInfo}>
                        <div>{parseInt(localStorage.getItem('language')) === 1 
                        ? "Extra Services:" 
                        :  "خدمات إضافية:"}</div>
                        {props.extraServices?.map(service =>
                            <div key={service.id}>
                            {parseInt(localStorage.getItem('language')) === 1 
                        ?  service.description
                        :  service.description_ar}</div>
                        )}
                    </div>
                    <div className={classes.ContactInfo}>
                        <div>{parseInt(localStorage.getItem('language')) === 1 
                        ? "For questions and inquiries:" 
                        :  "للاستفسار:"}</div>
                        <div>+962 79 666 00 22</div>
                        <div>{parseInt(localStorage.getItem('language')) === 1 
                        ? "Or send us a message below" 
                        :  "أو إرسال رسالة أدناه"}</div>
                    </div>
                    <Form />
                </div>
            </div>
        </div>
    )
}
export default Sessions;